import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { CtaButton } from './ui/CtaButton';
import { bonuses, PRICE_LABEL } from '../data/content';
export function BonusSection() {
  const [featured, ...rest] = bonuses;
  return <section className="border-b border-line bg-sand" data-id="element-19" data-mp="22dahutok8dtt">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-20" data-mp="1yfcr3mf55job">
        <div className="max-w-2xl" data-id="element-21" data-mp="1ao7ah51dmncy">
          <Eyebrow data-id="element-22" data-mp="1ap8q7mtc7y10">Incluido hoy sin costo extra</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-23" data-mp="15pmdrflc2lt9">
            Los bonos irresistibles
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-24" data-mp="1jic1ppkfa0t0">
            Cinco guías gratis que resuelven lo que ningún método toca: diagnóstico del alumno,
            seguimiento del progreso, calentamientos, motivación y correcciones en clase.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-25" data-mp="my3ar8rb77r8">
          <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-gold/30 bg-gold-soft" data-id="element-26" data-mp="29suy2pe2bn1g">
            <div className="grid gap-6 p-6 sm:grid-cols-[minmax(0,200px)_1fr] sm:items-start sm:p-8" data-id="element-27" data-mp="2eq4mq2tmnuo8">
              <img src={featured.cover} alt={`Portada del bono: ${featured.title}`} className="w-full rounded-xl border border-gold/20 object-cover shadow-card" loading="lazy" data-id="element-28" data-mp="2jj7goc2bh64y" />
              <div className="flex h-full flex-col" data-id="element-29" data-mp="1vs217y0agfv6">
                <div className="flex items-baseline justify-between gap-4" data-id="element-30" data-mp="1vstw16m2a9ke">
                  <span className="text-[11px] font-semibold uppercase tracking-eyebrow text-gold" data-id="element-31" data-mp="20qdao7mo8ocv">
                    Bono {featured.number}
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-eyebrow text-gold" data-id="element-32" data-mp="3c6tued59dr5j">
                    {featured.value}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-2xl font-semibold leading-tight text-ink sm:text-[28px]" data-id="element-33" data-mp="3h7hl0xpks5z8">
                  {featured.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-34" data-mp="1c3smh8197et5">
                  {featured.description}
                </p>
                <p className="mt-auto flex items-center gap-2 pt-6 text-xs uppercase tracking-eyebrow text-ink-mute" data-id="element-35" data-mp="1m2i5530z53ag">
                  <GiftIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-36" data-mp="yce515mzvlo7" />
                  PDF enviado a tu email
                </p>
              </div>
            </div>
          </article>

          <ul className="grid gap-4" data-id="element-37" data-mp="174zaxl5j1xvm">
            {rest.map(bonus => <li key={bonus.number} className="flex gap-4 rounded-xl border border-line bg-paper p-4 sm:p-5" data-id="element-38" data-mp="17729wuonr1ch">
                <img src={bonus.cover} alt={`Portada del bono: ${bonus.title}`} className="h-24 w-24 shrink-0 rounded-lg border border-line object-cover" loading="lazy" data-id="element-39" data-mp="enltrbk2el93" />
                <div className="min-w-0" data-id="element-40" data-mp="59uvhk60vjg9">
                  <div className="flex items-baseline justify-between gap-3" data-id="element-41" data-mp="5awi8lwehudt">
                    <span className="text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-42" data-mp="3mre3t5y5dvvm">
                      Bono {bonus.number}
                    </span>
                    <span className="shrink-0 text-[11px] font-semibold uppercase tracking-eyebrow text-gold" data-id="element-43" data-mp="ja5mqob8v01y">
                      {bonus.value}
                    </span>
                  </div>
                  <h3 className="mt-2 font-display text-[17px] font-semibold leading-snug text-ink" data-id="element-44" data-mp="9byjt9dsiiiy">
                    {bonus.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-ink-soft" data-id="element-45" data-mp="e8ye6n1a1wu8">
                    {bonus.description}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 flex flex-col gap-6 rounded-2xl border border-ink/10 bg-paper p-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-46" data-mp="2yynt101zdimx">
          <div className="max-w-xl" data-id="element-47" data-mp="3agez7lvzow62">
            <h3 className="font-display text-2xl font-semibold text-ink" data-id="element-48" data-mp="3ag545jw37yti">
              Los 5 bonos, gratis para vos
            </h3>
            <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-49" data-mp="30jipjcucu3zx">
              Todos los bonos vienen incluidos con el pack hoy — todos en PDF, enviados a tu
              email. Sin upsells, sin costos extra.
            </p>
          </div>
          <div className="lg:w-72 lg:shrink-0" data-id="element-50" data-mp="3t8h6w7qnl246">
            <CtaButton size="md" data-id="element-51" data-mp="3o8l3oaps5epo">Reservá el pack por {PRICE_LABEL}</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}